import { inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { TeacherApiService } from '@shared/services';
import { FormConfig } from '../edit-create-form.interfaces';
import { TEACHER_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';

export const teacherMinmaxHistoryFormConfig = (): FormConfig => {
  const teacherApiService = inject(TeacherApiService);

  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'teacherId', label: 'Giáo viên', required: true, width: 'full',
        type: 'select', config: { ...TEACHER_SELECT_CONFIG, service: teacherApiService },
        disabled: (editMode) => editMode
      },
      {
        key: 'fromDate', label: 'Từ ngày', required: true, width: '1/2',
        type: 'datepicker', placeholder: 'Chọn ngày bắt đầu'
      },
      {
        key: 'minClass', label: 'Số lớp min', required: true, width: '1/4',
        type: 'text', placeholder: 'Nhập số lớp min',
        validators: [Validators.pattern(/^\d+$/), Validators.min(0)],
        customErrorMessage: 'Số lớp min phải là số nguyên không âm'
      },
      {
        key: 'maxClass', label: 'Số lớp max', required: true, width: '1/4',
        type: 'text', placeholder: 'Nhập số lớp max',
        validators: [Validators.pattern(/^\d+$/), Validators.min(0)],
        customErrorMessage: 'Số lớp max phải là số nguyên không âm'
      },
      {
        key: 'note', label: 'Ghi chú', required: false, width: 'full',
        type: 'textarea', placeholder: 'Nhập ghi chú'
      }
    ]
  };
};
